import axios from 'axios';
import store from '../../state/store';
import { env } from '../../config/env';

const API_PREFIX = '/api/v1';

export const backendClient = axios.create({
    baseURL: `${env.BACKEND_SERVER}${API_PREFIX}/`,
    withCredentials: true,
});

backendClient.interceptors.request.use((config) => {
    const rel = String(config.url || '');
    const skipAuth = rel === 'auth/login' || rel.endsWith('/auth/login');
    if (!skipAuth) {
        const jwt = store.getState()?.userCredential?.jwt;
        if (jwt) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${jwt}`;
        }
    }
    return config;
}, (err) => Promise.reject(err));
